//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import teamInfo from "./teamInfo.vue";
import studentmanage from "./studentmanage.vue";
import trainmanage from "./trainmanage.vue";
import eventmanage from "./eventmanage.vue";
import parentList from "./parent-list.vue"; // import { loadMoreList,commonData  } from "@/mixins/index";

export default {
  name: "teammanage",
  components: {
    teamInfo: teamInfo,
    studentmanage: studentmanage,
    trainmanage: trainmanage,
    eventmanage: eventmanage,
    parentList: parentList
  },
  // mixins: [ loadMoreList ,commonData],
  data: function data() {
    return {
      activeIndex: 'teamInfo',
      teamId: ''
    };
  },
  created: function created() {
    console.log("this.$route.query", this.$route.query);
    this.teamId = this.$route.query.teamId || sessionStorage.getItem('teamId');
    console.log("this.teamId==", this.teamId); // this.getList();
  },
  methods: {
    handover: function handover(index) {
      this.activeIndex = index;
    }
  }
};